import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect, useSelector } from "react-redux";

import {
  changeLayout,
  changeTopbarTheme,
  toggleRightSidebar,
  changeLayoutWidth,
} from "../../../store/actions";

// Other Layout related Component
// import RightSidebar from "../RightSidebar";
import TopBar from "./TopBar";
import Footer from "./Footer";
import Navbar from "./Navbar";

class Layout extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMenuOpened: false
    };
    this.toggleRightSidebar = this.toggleRightSidebar.bind(this);
  }

  /**
   * Open/close right sidebar
   */
  toggleRightSidebar() {
    this.props.toggleRightSidebar();
  }

  componentDidMount() {
    window.scrollTo(0, 0);

      this.props.changeLayout('horizontal');
      if (this.props.topbarTheme) {
        this.props.changeTopbarTheme(this.props.topbarTheme);
      }
      if (this.props.layoutWidth) {
        this.props.changeLayoutWidth(this.props.layoutWidth);
      }
      // if(this.props.showRightSidebar) {
      //   this.toggleRightSidebar();
      // }
  }

  /**
   * Opens the menu - mobile
   */
  openMenu = e => {
    this.setState({ isMenuOpened: !this.state.isMenuOpened });
  };

  closeMenu = e => {
    this.setState({ isMenuOpened: false });
  };

  render() {
    const { user } = this.props;
    const isSuporte = user?.perfil === 'SUPORTE_AGRARE';

    return (
      <React.Fragment>
        <div id="layout-wrapper">
          <TopBar
            theme={this.props.topbarTheme}
            isMenuOpened={this.state.isMenuOpened}
            toggleRightSidebar={this.toggleRightSidebar}
            openLeftMenuCallBack={this.openMenu}
          />

          {isSuporte && (
            <Navbar
              menuOpen={this.state.isMenuOpened}
              funcCloseMenu={this.closeMenu}
            />
          )}

          <div className="main-content">
            <div style={{ marginTop: isSuporte ? '120px' : '75px' }}>
              {this.props.children}
            </div>
          </div>
          <Footer />
          {/* <RightSidebar /> */}
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = state => {
  return {
    ...state.Layout,
    user: state.entities.loginReducer?.user
  };
};
export default connect(mapStatetoProps, {
  changeTopbarTheme, toggleRightSidebar, changeLayout, changeLayoutWidth
})(withRouter(Layout));
